import(/* webpackMode: "eager" */ "/home/youidan/workspace/yinziai-web-explore/apps/web/app/[locale]/error.tsx");
